import React from 'react'

import type { IconProps } from './types'

const WeightTracker: React.FC<IconProps> = ({
  size = 24,
  color = '#595959',
  ...rest
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.585 6.057A2.53 2.53 0 0 1 5.097 3.25h13.806a2.53 2.53 0 0 1 2.512 2.807l-.67 6.026a.75.75 0 0 1-1.49-.166l.67-6.026a1.03 1.03 0 0 0-1.022-1.141H5.097c-.612 0-1.089.532-1.021 1.141l1.383 12.445c.057.52.497.914 1.021.914H12a.75.75 0 0 1 0 1.5H6.48a2.53 2.53 0 0 1-2.512-2.249z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="m8.67 9.336-.002.006.001-.003.021-.036q.032-.055.113-.166a3 3 0 0 1 .54-.551c.502-.402 1.34-.836 2.657-.836 1.318 0 2.155.434 2.656.836.256.204.432.406.54.551a2 2 0 0 1 .135.202l.002.003-.003-.006v.003l.002.001v.002a.75.75 0 0 0 1.339-.677l-.659.329c.659-.33.66-.329.659-.33l-.001-.001V8.66l-.003-.004-.006-.01-.069-.122a4 4 0 0 0-.195-.287 4.6 4.6 0 0 0-.803-.824C14.845 6.816 13.682 6.25 12 6.25s-2.845.566-3.593 1.164c-.37.296-.632.594-.804.824a4 4 0 0 0-.264.408l-.006.01-.002.005v.002c-.001 0-.002.002.669.337l-.67-.335a.75.75 0 0 0 1.338.677M15.25 15a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-2.19l-3.72 3.72a.75.75 0 0 1-1.06-1.06l3.72-3.72H16a.75.75 0 0 1-.75-.75"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.03 9.47a.75.75 0 0 1 0 1.06l-1.5 1.5a.75.75 0 0 1-1.06-1.06l1.5-1.5a.75.75 0 0 1 1.06 0"
        fill={color}
      />
    </svg>
  )
}

export default WeightTracker
